<template>
    <v-form ref="form" @submit="submit" v-model="formValid" class="call-configs">
        <!-- Header title -->
        <div class="title-config">
            <div class="title">{{ $f.tc('autoCall') }}</div>
            <div style="display: flex; align-items: center">
                <div class="btn-custom" @click="submit">{{ $f.tc('save') }}</div>
            </div>
        </div>

        <!-- Content -->
        <div class="fci-scrollbar">
            <!-- Voice profile -->
            <div style="padding:20px">
                <div class="child-title" style="padding: 0!important;">{{ $f.tc('voiceProfile') }}</div>
                <div style="font-size: 14px; color: #96ADD0; padding-bottom: 20px" v-if="voiceSpeedList.length === 0">
                    {{ $f.tc('noDataAvailable') }}
                </div>
                <div v-else>
                    <div class="row-config label" style="margin-bottom: 8px">
                        <div style="font-weight: 700; font-size: 13px; width: 65%">{{ $f.tc('voice') }}</div>
                        <div style="font-weight: 700; font-size: 13px">{{ $f.tc('speed') }}</div>
                        <div class="config-action"></div>
                    </div>
                    <div class="row-config" v-for="(voice, index) in voiceSpeedList" :key="index"
                         style="margin-bottom: 8px">
                        <v-select
                            v-model="voice.voice.id"
                            :items="voices"
                            item-value="id"
                            item-text="name"
                            :rules="[formRules.ruleRequired]"
                            :class="'input-custom'"
                            style="margin-right: 7px!important;"
                        >
                            <template v-slot:item="{ item }">
                                <v-tooltip v-if="item.description" top>
                                    <template v-slot:activator="{ on }">
                                        <img v-if="item.description"
                                             src="/img/more_detail.svg"
                                             alt="icon-more-detail" style="width: 15px;">
                                    </template>
                                    <span>{{ item.description }}</span>
                                </v-tooltip>
                                <span :class="item.description ? 'pl-6' : ''">{{ item.name }}</span>
                            </template>
                            <template v-slot:selection="{ item }" class="centerXY">
                                <img v-if="item.description" :title="item.description"
                                     src="/img/more_detail.svg"
                                     alt="icon-more-detail" style="width: 15px;">
                                <span :class="item.description ? 'pl-6' : ''">{{ item.name }}</span>
                            </template>
                        </v-select>
                        <v-text-field
                            v-model="voice.speed"
                            hide-details
                            single-line
                            type="number"
                            min="0.5"
                            max="2"
                            step="0.1"
                            class="input-custom"
                            style="margin-right: 7px!important;width: 15%"
                            @keypress="filterNumber($event)"
                        ></v-text-field>
                        <div class="config-action">
                            <div class="btn-icon" @click="removeVoiceSpeed(index)">
                                <img src="/img/delete-blue.svg" alt="icon-delete-voice-profile"
                                     style="transform: scale(1.2); padding-left: 1px">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="centerY justify-start">
                    <div class="btn-outline" @click="addVoiceSpeed()">
                        <img src="/img/add-blue.svg" alt="icon-add-voice-profile"
                             style="margin-right: 6px; transform: scale(1.1)">
                        {{ $f.tc('voiceProfile') }}
                    </div>
                </div>

                <!-- PERSONALIZE VOICE PROFILE -->
                <div>
                    <div class="centerY mt-12"
                         :class="showAdvanceSetting ? 'mb-6' : ''">
                        <div class="centerY" style="cursor: pointer;" @click="togglePersonalizeVoiceProfile">
                            <div class="voice-profile-title mr-1"
                                 :style="{color: `${!showAdvanceSetting ? '#96ADD0' : '#2c3e50'} !important`}">
                                {{ $f.tc('personalizeVoiceProfile') }}
                            </div>
                            <img src="/img/arrow-down.svg" alt="icon-expand-voice-profile"
                                 style="width: 20px; transition: 0.3s"
                                 :style="showAdvanceSetting ? {transform: `rotate(180deg)`} : ''">
                            <img v-show="showPersonalizeVoiceError" src="/img/warning.svg"
                                 alt="icon-warning-validate-voice-profile"
                                 style="width: 20px"
                            >
                        </div>
                        <div style="flex:1"></div>
                    </div>
                    <v-expand-transition>
                        <div v-if="showAdvanceSetting">
                            <div class="row-config" style="margin-top: 5px; position: relative"
                                 v-for="(item, index) in personalizeVoices" :key="index"
                                 :style="showAdvanceSetting ? {marginBottom: '8px'} : ''">
                                <!-- content of profile -->
                                <div class="voice-profile" style="width:100%">
                                    <div class="voice-profile-header">
                                        <div class="label">{{ $f.tc('name') }}</div>
                                        <div style="position: absolute; top:0; right:0">
                                            <v-btn small icon @click="deletePersonalizeVoiceProfile(index) ">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </div>

                                    </div>
                                    <v-text-field
                                        outlined
                                        type="string"
                                        v-model="item.name"
                                        placeholder="voice profile name"
                                        :rules="[formRules.ruleRequired]"
                                        class="input-custom input-number"
                                    ></v-text-field>

                                    <!-- voice select for group -->
                                    <div>
                                        <div class="centerY mb-8 mt-8">
                                            <div class="label mb-0">{{ $f.tc('voices') }}</div>
                                            <img src="/img/add-blue.svg" alt="icon-add-voice-to-group"
                                                 style="margin-left: 5px; transform: scale(1.1); cursor: pointer"
                                                 @click="addVoiceToGroup(index)">
                                        </div>
                                        <div v-if="item.voices.length === 0">
                                            {{ $f.tc('noDataAvailable') }}
                                        </div>
                                        <div v-else class="row-config" v-for="(voice, idx) in item.voices" :key="idx"
                                             style="margin-bottom: 8px">
                                            <v-select
                                                v-model="voice.voice.id"
                                                :items="voices"
                                                item-value="id"
                                                item-text="name"
                                                :rules="[formRules.ruleRequired]"
                                                :class="'input-custom'"
                                                style="margin-right: 7px!important;"
                                            >
                                                <template v-slot:item="{ item }">
                                                    <v-tooltip v-if="item.description" top>
                                                        <template v-slot:activator="{ on }">
                                                            <img v-if="item.description"
                                                                 src="/img/more_detail.svg"
                                                                 alt="icon-more-detail" style="width: 15px;">
                                                        </template>
                                                        <span>{{ item.description }}</span>
                                                    </v-tooltip>
                                                    <span :class="item.description ? 'pl-6' : ''">{{ item.name }}</span>
                                                </template>
                                                <template v-slot:selection="{ item }" class="centerXY">
                                                    <img v-if="item.description"
                                                         :title="item.description"
                                                         src="/img/more_detail.svg"
                                                         alt="icon-more-detail" style="width: 15px;">
                                                    <span :class="item.description ? 'pl-6' : ''">{{ item.name }}</span>
                                                </template>
                                            </v-select>

                                            <v-text-field
                                                v-model="voice.speed"
                                                single-line
                                                type="number"
                                                min="0.5"
                                                max="2"
                                                step="0.1"
                                                class="input-custom"
                                                placeholder="speed"
                                                :rules="[formRules.ruleRequired, validateVoiceSpeed]"
                                                style="margin-right: 7px!important;width: 15%"
                                                @keypress="filterNumber($event)"
                                            ></v-text-field>
                                            <div class="config-action">
                                                <div class="btn-icon" @click="removeVoiceFromGroup(index, idx)">
                                                    <img src="/img/delete-blue.svg" alt="icon-delete-voice-from-profile"
                                                         style="transform: scale(1.2); padding-left: 1px">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Rules select for group -->
                                    <div>
                                        <div class="centerY mb-8 mt-8">
                                            <div class="label mb-0">{{ $f.tc('rules') }}</div>
                                            <img src="/img/add-blue.svg" alt="icon-add-voice-to-group"
                                                 style="margin-left: 5px; transform: scale(1.1); cursor: pointer"
                                                 @click="addRuleToGroup(index)">
                                        </div>
                                        <div v-if="Object.keys(item.rules).length === 0">
                                            {{ $f.tc('noDataAvailable') }}
                                        </div>
                                        <div v-else class="row-config" v-for="(rule, i) in item.rules" :key="i"
                                             style="margin-bottom: 8px">
                                            <v-text-field
                                                outlined
                                                type="string"
                                                v-model="rule.key"
                                                :rules="[formRules.ruleRequired]"
                                                class="input-custom"
                                                placeholder="key"
                                                style="margin-right: 7px!important;width: 20%;"
                                            ></v-text-field>
                                            <v-text-field
                                                v-model="rule.value"
                                                single-line
                                                type="string"
                                                :rules="[formRules.ruleRequired]"
                                                class="input-custom"
                                                placeholder="value"
                                                style="margin-right: 7px!important;width: 15%"
                                            ></v-text-field>
                                            <div class="config-action">
                                                <div class="btn-icon" @click="removeRuleFromGroup(index, i)">
                                                    <img src="/img/delete-blue.svg" alt="icon-delete-rule-from-profile"
                                                         style="transform: scale(1.2); padding-left: 1px">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="centerY justify-start">
                                <div class="btn-outline" @click="addPersonalizeVoiceProfile">
                                    <img src="/img/add-blue.svg" alt="icon-add-voice-profile"
                                         style="margin-right: 6px; transform: scale(1.1) ">
                                    {{ $f.tc('personalizeVoiceProfile') }}
                                </div>
                            </div>

                        </div>
                    </v-expand-transition>
                </div>
            </div>

            <!-- recall setting -->
            <div style="padding: 20px; border-top: 1px solid #D9D9D9">
                <div class="child-title">{{ $f.tc('callSettings') }}</div>
                <div class="centerY" style="gap: 8px">
                    <!-- Maximum number of calls -->
                    <div style="flex: 1">
                        <div class="centerY">
                            <div class="label">{{ $f.tc('maxNumberCall') }}</div>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" color="#96ADD0" class="call-settings-tooltips">mdi-information</v-icon>
                                </template>
                                <span>{{ $f.tc('maxNumberCallTooltip') }}</span>
                            </v-tooltip>
                        </div>
                        <v-text-field
                            outlined
                            type="number"
                            v-model="config.recall_times"
                            :min="0"
                            :rules="[formRules.ruleRequired, formRules.rulePositiveNumber]"
                            class="input-custom input-number"

                        ></v-text-field>
                    </div>

                    <!-- Call interval (minutes) -->
                    <div style="flex: 1">
                        <div class="centerY">
                            <div class="label">{{ $f.tc('callInterval') }}</div>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" color="#96ADD0" class="call-settings-tooltips">mdi-information</v-icon>
                                </template>
                                <span>{{ $f.tc('callIntervalTooltip') }}</span>
                            </v-tooltip>
                        </div>
                        <v-text-field
                            outlined
                            type="number"
                            v-model="config.after_each"
                            :min="0"
                            :rules="[formRules.ruleRequired, formRules.rulePositiveNumber]"
                            class="input-custom input-number"
                        ></v-text-field>
                    </div>

                    <!-- Ringing time -->
                    <div style="flex: 1">
                        <div class="centerY">
                            <div class="label">{{ $f.tc('ringingTime') }} (s)</div>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" color="#96ADD0" class="call-settings-tooltips">mdi-information</v-icon>
                                </template>
                                <span>{{ $f.tc('ringingTimeTooltip') }}</span>
                            </v-tooltip>
                        </div>
                        <v-text-field
                            outlined
                            type="number"
                            v-model="config.ringing_time"
                            :min="16"
                            :max="60"
                            @focusout="validateRingingTime"
                            :rules="[formRules.ruleRequired, formRules.rulePositiveNumber]"
                            class="input-custom input-number"
                        ></v-text-field>
                    </div>
                </div>
            </div>

            <!-- Call schedule -->
            <div style="padding: 20px; border-top: 1px solid #D9D9D9">
                <div class="child-title">{{ $f.tc('allowedCallingTime') }}</div>
                <div style="font-size: 14px; color: #96ADD0;" v-if="itemList.length === 0">
                    {{ $f.tc('noDataAvailable') }}
                </div>
                <div v-else>
                    <div class="row-config label" style="margin-bottom: 8px">
                        <div class="config-repeat" style="font-weight: 700; font-size: 13px;">{{
                                $f.tc('repeat')
                            }}
                        </div>
                        <div class="config-from" style="font-weight: 700; font-size: 13px;">{{ $f.tc('from') }}</div>
                        <div class="config-to" style="font-weight: 700; font-size: 13px;">{{ $f.tc('to') }}</div>
                        <div class="config-action"></div>
                    </div>
                    <div class="row-config" v-for="(schedule, index) in itemList" :key="index"
                         style="margin-bottom: 8px">
                        <div class="config-repeat">
                            <v-select
                                v-model="schedule.repeat"
                                :items="repeatList"
                                item-value="key"
                                item-text="value"
                                :rules="[formRules.ruleRequired]"
                                class="input-custom"
                            >
                            </v-select>
                        </div>
                        <div class="config-from">
                            <DateTimeInput
                                v-model="schedule.from_time"
                                :emit-time-only="true"
                                type="time"
                                :rules="[formRules.ruleRequired]"
                                :width="212"
                                :use-seconds="true"
                            ></DateTimeInput>
                        </div>
                        <div class="config-to">
                            <DateTimeInput
                                v-model="schedule.to_time"
                                :emit-time-only="true"
                                type="time"
                                :min="schedule.from_time"
                                :rules="[formRules.ruleRequired]"
                                :width="212"
                                :use-seconds="true"
                            ></DateTimeInput>
                        </div>
                        <div class="config-action">
                            <div class="btn-icon" @click="removeItem(index)">
                                <img src="/img/delete-blue.svg" alt="icon-delete-calling-schedule"
                                     style="transform: scale(1.2); padding-left: 1px">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="centerY justify-start">
                    <div class="btn-outline" @click="addItem()">
                        <img src="/img/add-blue.svg" alt="icon-add-calling-day"
                             style="margin-right: 6px; transform: scale(1.1);">
                        {{ $f.tc('addNew') }}
                    </div>
                </div>
            </div>
        </div>
    </v-form>
</template>

<script>
import FormMixin from "@/modules/fptai/mixins/FormMixin";
import CampaignService from "@/services/campaign.service";
import {mapState} from "vuex";
import BaseConfig from "@/views/Campaign/Form/Step4/BaseConfig";
import DateTimeInput from "@/components/DateTimeInput";
import lodash from "lodash";

const campaignConfigDefault = {
    concurrent_call: 20,
    recall_times: 1,
    after_each: 60,
    max_calling_duration: 5,
    voice_speed: 1,
    ringing_time: 45,
}

export default {
    name: "AutoCallConfig",
    components: {DateTimeInput},
    mixins: [FormMixin],
    extends: BaseConfig,
    data() {
        return {
            voices: [],
            maxConcurrentCalls: 20,
            config: this.$utils.cloneObject(campaignConfigDefault),
            repeatList: [],
            emptyItem: {
                repeat: '',
                from_time: '00:00',
                to_time: '23:59'
            },
            loadFn: CampaignService.getSchedules,
            saveFn: CampaignService.addSchedule,
            updateFn: CampaignService.updateSchedule,
            deleteFn: CampaignService.removeSchedule,
            // speed default
            voiceSpeedList: [],
            voiceProfile: {
                voice: {},
                speed: 1.0,
            },
            voiceProfileMap: {},
            oldConfig: {},
            personalizeVoices: [],
            personalizeVoiceProfile: {
                name: '',
                voices: [{
                    voice: {},
                    speed: '',
                }],
                rules: [
                    {
                        key: "",
                        value: ""
                    }
                ]
            },
            showAdvanceSetting: false,
            newRule: {
                key: "",
                value: ""
            },
            personalizeVoiceMap: [],
            showPersonalizeVoiceError: false
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign,
            campaignConfig: state => state.campaign.campaignConfig,
        })
    },
    mounted() {
        if (this.campaign.direction === 'OUTBOUND') {
            this.getVoices()
            this.getVoiceSpeed()
            this.getPersonalizeVoiceProfile()
            this.getRepeats()
        }
    },
    methods: {
        submitValidForm() {
            // save schedules
            this.saveForm()
            // save voice speed
            this.saveVoiceSpeed()
            // save config
            this.saveConfigs()
            // save voice profile
            this.saveVoiceProfile()
        },
        getVoiceSpeed() {
            let campaignId = this.campaign.id ? this.campaign.id : this.$route.params.campaignId
            CampaignService.VoiceSpeedService.search(campaignId).then(
                result => {
                    this.voiceSpeedList = result.data
                    // map voice profile
                    result.data.forEach(item => {
                        this.voiceProfileMap[item.id] = item
                    })
                    this.voiceProfileMap = this.$utils.cloneObject(this.voiceProfileMap)
                }
            ).catch(this.$appService.handleRequestError(this.$t('actionFailed', {
                action: 'load',
                item: 'voice speed'
            })))
        },
        togglePersonalizeVoiceProfile() {
            this.showAdvanceSetting = !this.showAdvanceSetting
        },
        getPersonalizeVoiceProfile() {
            let campaignId = this.campaign.id ? this.campaign.id : this.$route.params.campaignId
            CampaignService.VoiceGroupService.search(campaignId).then(
                result => {
                    this.personalizeVoices = result.data
                    this.personalizeVoices.forEach(item => {
                        let rules = JSON.parse(item.rules)
                        let temp = []
                        Object.keys(rules).forEach(key => {
                            let rule = {
                                'key': key,
                                'value': rules[key]
                            }
                            temp.push(rule)
                        })
                        item.rules = temp
                        this.personalizeVoiceMap[item.id] = this.$utils.cloneObject(item)
                    })
                }
            ).finally(() => {
                if (this.personalizeVoices.length > 0 && !this.showAdvanceSetting) {
                    this.togglePersonalizeVoiceProfile()
                }
            })
        },
        addVoiceSpeed() {
            this.voiceSpeedList.push(this.$utils.cloneObject(this.voiceProfile))
        },
        addPersonalizeVoiceProfile() {
            this.personalizeVoices.push(this.$utils.cloneObject(this.personalizeVoiceProfile))
        },
        deletePersonalizeVoiceProfile(index) {
            let item = this.personalizeVoices[index]
            let deleteMessage = this.$f.tc('delete') + ' ' + this.$t('voiceGroup') + ' ' + item.name
            this.$appService.confirm(deleteMessage).then(
                confirm => {
                    if (confirm) {
                        if (item.id) {
                            CampaignService.VoiceGroupService.delete(this.campaign.id, item.id).then(
                                () => {
                                    this.$appService.toastSuccess(this.$t('actionSuccessful', {
                                        action: this.$f.tc('delete'),
                                        item: this.$f.tc('voiceGroup')
                                    }))
                                }
                            )
                        }
                        this.personalizeVoices.splice(index, 1)
                    }
                }
            )
        },
        addVoiceToGroup(index) {
            this.personalizeVoices[index]['voices'].push(this.$utils.cloneObject(this.voiceProfile))
        },
        removeVoiceFromGroup(index, idx) {
            let group = this.personalizeVoices[index]
            let item = group['voices'][idx]
            let deleteMessage = this.$f.tc('delete') + ' ' + this.$t('voice') + ' ' + item.voice.name
            this.$appService.confirm(deleteMessage).then(
                confirm => {
                    if (confirm) {
                        if (group['voices'].length === 1) {
                            this.$appService.toastError(this.$t('actionFailed', {
                                action: this.$f.tc('delete'),
                                item: this.$f.tc('voiceProfile')
                            }))
                            return
                        }
                        group['voices'].splice(idx, 1)
                        if (group.id) {
                            let model = {
                                "voices": group['voices']
                            }
                            CampaignService.VoiceGroupService.update(this.campaign.id, group.id, model).then(
                                () => {
                                    this.$appService.toastSuccess(this.$t('actionSuccessful', {
                                        action: this.$f.tc('delete'),
                                        item: this.$f.tc('voice')
                                    }))
                                }
                            ).finally(this.getPersonalizeVoiceProfile)
                        }
                    }
                }
            )
        },
        addRuleToGroup(index) {
            this.personalizeVoices[index]["rules"].push(this.$utils.cloneObject(this.newRule))
        },
        removeRuleFromGroup(index, i) {
            let group = this.personalizeVoices[index]
            let item = group['rules'][i]
            let deleteMessage = this.$f.tc('delete') + ' ' + this.$t('rule') + ' ' + item.key
            this.$appService.confirm(deleteMessage).then(
                confirm => {
                    if (confirm) {
                        if (group['rules'].length === 1) {
                            this.$appService.toastError(this.$t('actionFailed', {
                                action: this.$f.tc('delete'),
                                item: this.$f.tc('rule')
                            }))
                            return
                        }
                        group['rules'].splice(i, 1)
                        if (group.id) {
                            let rules = {}
                            group['rules'].forEach(i => {
                                rules[i.key] = i.value
                            })
                            let model = {
                                "rules": JSON.stringify(rules)
                            }
                            CampaignService.VoiceGroupService.update(this.campaign.id, group.id, model).then(
                                () => {
                                    this.$appService.toastSuccess(this.$t('actionSuccessful', {
                                        action: this.$f.tc('delete'),
                                        item: this.$f.tc('rule')
                                    }))
                                }
                            ).finally(this.getPersonalizeVoiceProfile)
                        }
                    }
                }
            )
        },
        saveVoiceSpeed() {
            let saveSuccessCount = 0
            let saveFailCount = 0
            let updateSuccessCount = 0
            let updateFailCount = 0
            let noChangeCount = 0
            let oldProfileMap = this.voiceProfileMap
            let finallyFunction = () => {
                if (saveSuccessCount + saveFailCount + updateSuccessCount + updateFailCount + noChangeCount === this.voiceSpeedList.length) {
                    let i18nSave = {
                        action: this.$f.tc('save'),
                        item: this.$t('voiceProfile')
                    }
                    if (saveSuccessCount > 0) {
                        this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18nSave) + ': ' + saveSuccessCount)
                    }
                    if (saveFailCount > 0) {
                        this.$appService.toastError(this.$f.tc('actionFailed', i18nSave) + ': ' + saveFailCount)
                    }
                    let i18nUpdate = {
                        action: this.$f.tc('update'),
                        item: this.$t('voiceProfile')
                    }
                    if (updateSuccessCount > 0) {
                        this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18nUpdate) + ': ' + updateSuccessCount)
                    }
                    if (updateFailCount > 0) {
                        this.$appService.toastError(this.$f.tc('actionFailed', i18nUpdate) + ': ' + updateFailCount)
                    }
                    if (saveFailCount + updateFailCount === 0) {
                        this.getVoiceSpeed()
                    }
                }
            }
            for (let item of this.voiceSpeedList) {
                let model = {
                    voice: item.voice.id,
                    speed: item.speed,
                }
                if (item.id) {
                    // compare old and new
                    let oldItem = oldProfileMap[item.id]
                    if (JSON.stringify(oldItem) === JSON.stringify(item)) {
                        noChangeCount++
                        continue
                    }
                    CampaignService.VoiceSpeedService.update(this.campaign.id, item.id, model).then(
                        () => updateSuccessCount++,
                        () => updateFailCount++
                    ).finally(finallyFunction)
                } else {
                    CampaignService.VoiceSpeedService.create(this.campaign.id, model).then(
                        () => saveSuccessCount++,
                        () => saveFailCount++
                    ).finally(finallyFunction)
                }
            }
        },
        removeVoiceSpeed(index) {
            let item = this.voiceSpeedList[index]
            if (!item.id) {
                this.voiceSpeedList.splice(index, 1)
                return
            }
            // khong xoa item cuoi cung
            if (this.voiceSpeedList.length === 1) {
                this.$appService.toastError(this.$t('actionFailed', {
                    action: this.$f.tc('delete'),
                    item: this.$f.tc('voiceProfile')
                }))
                return
            }
            CampaignService.VoiceSpeedService.delete(this.campaign.id, item.id).then(
                () => {
                    this.$appService.toastSuccess(this.$t('actionSuccessful', {
                        action: this.$f.tc('delete'),
                        item: this.$f.tc('voiceProfile')
                    }))
                    this.getVoiceSpeed()
                }).catch(this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$f.tc('delete'),
                    item: this.$f.tc('voiceProfile')
                }))
            )
        },
        getVoices() {
            CampaignService.getVoices().then(
                result => {
                    if (result.data.length) {
                        this.voices = [...result.data]
                        for (let dataKey in result.data) {
                            if (result.data[dataKey]['default']) {
                                this.voiceProfile.voice = result.data[dataKey]
                                break
                            }
                        }
                    }
                    this.$nextTick().then(() => {
                        this.$appService.dataLoading(false)
                        this.$refs.form.resetValidation()
                    })
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: 'load',
                    item: 'voice'
                }))
            )
        },
        saveConfigs() {
            // compare old config and new config
            let isChange = false
            if (!lodash.isEqual(this.oldConfig, this.config)) {
                isChange = true
            }
            if (!isChange) {
                return
            }
            let i18n = {
                action: this.$t('save'),
                item: this.$t('config')
            }
            CampaignService.saveConfig(this.campaign, this.config).then(
                () => {
                    this.oldConfig = this.$utils.cloneObject(this.config)
                    this.$appService.handleRequestSuccess(this.$f.tc('actionSuccessful', i18n))()
                },
                (this.$appService.handleRequestError(this.$f.tc('actionFailed', i18n)))
            )
        },
        saveVoiceProfile() {
            this.personalizeVoices.forEach(voiceProfile => {
                let duplicate = false
                let i18nUpdate = {
                    item: this.$t('voiceGroup') + ' ' + voiceProfile.name,
                    action: this.$f.tc('update')
                }

                let i18nSave = {
                    item: this.$t('voiceGroup') + ' ' + voiceProfile.name,
                    action: this.$f.tc('save')
                }

                let model = {
                    name: voiceProfile.name,
                    voices: voiceProfile.voices
                }
                let rules = {}
                voiceProfile.rules.forEach(i => {
                    let k = i.key.trim()
                    let v = i.value.trim()
                    if (rules[k]) {
                        duplicate = true
                        return
                    }
                    rules[k] = v
                })
                model['rules'] = JSON.stringify(rules)

                let invalidVoice = false
                voiceProfile.voices.forEach(voice => {
                    if (parseFloat(voice.speed) <= 0.5 || parseFloat(voice.speed) >= 2) {
                        invalidVoice = true
                    }
                })

                if (duplicate) {
                    let errMsg = voiceProfile.id ? this.$f.tc('actionFailed', i18nUpdate) : this.$f.tc('actionFailed', i18nSave)
                    this.$appService.toastError(errMsg + ': duplicate rules')
                    return
                }

                if (invalidVoice) {
                    let errMsg = voiceProfile.id ? this.$f.tc('actionFailed', i18nUpdate) : this.$f.tc('actionFailed', i18nSave)
                    this.$appService.toastError(errMsg + ': invalid field')
                    this.showPersonalizeVoiceError = true
                    return
                }

                if (voiceProfile.id) {
                    if (!lodash.isEqual(voiceProfile, this.personalizeVoiceMap[voiceProfile.id]) && !duplicate) {
                        CampaignService.VoiceGroupService.update(this.campaign.id, voiceProfile.id, model).then(
                            this.getPersonalizeVoiceProfile
                        ).catch(() => {
                            this.$appService.toastError(this.$t('actionFailed', i18nUpdate))
                        }).finally(() => {
                            this.$appService.toastSuccess(this.$t('actionSuccessful', i18nUpdate))
                        })
                        this.showPersonalizeVoiceError = false
                    }
                } else {
                    model.campaign = this.campaign.id
                    CampaignService.VoiceGroupService.create(this.campaign.id, model).then(
                        this.getPersonalizeVoiceProfile
                    ).catch(() => {
                        this.$appService.toastError(this.$t('actionFailed', i18nSave))
                    }).finally(() => {
                        this.$appService.toastSuccess(this.$t('actionSuccessful', i18nSave))
                    })
                    this.showPersonalizeVoiceError = false
                }
            })
        },
        getRepeats() {
            CampaignService.getRepeatsData().then(
                result => {
                    result.data.forEach(item => {
                        item["value"] = this.$f.tc('schedule.' + `${item['key']}`)
                        this.repeatList.push(item)
                    })
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('load'),
                    item: 'repeatList'
                }))
            )
        },
        filterNumber(evt) {
            let expect = evt.target.value.toString() + evt.key.toString()
            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault()
            } else {
                return true
            }
        },
        validateRingingTime() {
            if (this.config.ringing_time > 60) {
                this.$appService.toastError(this.$f.tc('ringingTimeBetweenRangeTime'))
                this.config.ringing_time = 60
            }

            if (this.config.ringing_time < 16) {
                this.$appService.toastError(this.$f.tc('ringingTimeBetweenRangeTime'))
                this.config.ringing_time = 16
            }
        },
        validateVoiceSpeed(value) {
            //valid speed
            if (value >= 0.5 && value <= 2) {
                return true
            }
            return this.$t('voiceSpeedInvalid')
        },
    },
    watch: {
        campaignConfig: {
            deep: true,
            handler: function (newVal) {
                if (!newVal) {
                    this.config = this.$utils.cloneObject(campaignConfigDefault)
                    return
                }

                this.config = this.$utils.cloneObject(this.campaignConfig)
                if (!this.config && !this.config.ringing_time) {
                    this.config.ringing_time = 45
                }

                this.oldConfig = this.$utils.cloneObject(this.config)
            }
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .v-slider__thumb-label {
        border-radius: 50% 50% 0;
        transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);
    }

    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px;
    }

    .v-input__slot {
        margin-bottom: 0 !important;
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
            top: 7px;
        }

        .v-input__slot {
            padding: 6px 3px 6px 12px;
        }
    }

    .v-input--selection-controls {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-input__control {
        width: 100%;
    }
}

.child-title {
    font-size: 16px;
    font-family: 'open sans bold', serif;
    font-weight: 700;
    margin-bottom: 6px;
}

.title-config {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 20px;
    border-bottom: 1px solid #E4EDFA;
}

.label {
    font-family: "open sans semi", serif;
    margin-bottom: 6px;
    font-size: 13px;
}


.row-config {
    display: flex;
    align-items: center;

    .config-repeat, .config-from, .config-to {
        width: 210px;
        margin-right: 8px;
    }

    .config-action {
        width: 28px;
    }
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-text-field__details {
            right: 20px;
        }
    }
}

.voice-profile-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-family: 'open sans', serif;
    font-weight: 700;
}

.voice-profile {
    border-radius: 5px;
    border: 1px solid #D9D9D9;
    padding: 10px 12px;
}

.voice-profile-row-config {
    display: flex;
    align-items: center;

    .config-repeat, .config-from, .config-to {
        width: 210px;
        margin-right: 8px;
    }

    .config-action {
        width: 28px;
    }
}

.voice-profile-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.input-number {
    ::v-deep .v-text-field__details {
        right: 36px !important;
    }
}

.call-settings-tooltips {
    transform: scale(0.8);
    margin-bottom: 6px;
    margin-left: 2px;
}
</style>
